import React from 'react'
import styled, { keyframes } from 'styled-components'

interface INoConversationProps {
  style?: React.CSSProperties
}

const heartbeat = keyframes `
	0% {
		transform: scale(1)
	}
	10% {
		transform: scale(1.3)
	}
	30% {
		transform: scale(1)
	}
	40% {
		transform: scale(1)
	}
	50% {
		transform: scale(1.3)
	}
	60% {
		transform: scale(1)
	}
	to {
		transform: scale(1)
	}
`
const AnimateHit = styled.g`
animation: 1.5s Infinite linear ${heartbeat};
    animation-delay: 0s;
`

export const NoConversationIcon: React.FC<INoConversationProps> = ({ style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" style={style || {}}>
      <g
        className="animable"
        style={{
          transformOrigin: "250px 228.23px",
        }}
      >
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "250px 382.525px",
          }}
          className="animable"
          d="M0 382.4h500v.25H0z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "69.02px 398.615px",
          }}
          className="animable"
          d="M52.46 398.49h33.12v.25H52.46z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "157.58px 401.335px",
          }}
          className="animable"
          d="M135.33 401.21h44.5v.25h-44.5z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "121.79px 389.335px",
          }}
          className="animable"
          d="M86.58 389.21H157v.25H86.58z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "443.555px 391.015px",
          }}
          className="animable"
          d="M437.21 390.89h12.69v.25h-12.69z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "409.885px 391.015px",
          }}
          className="animable"
          d="M391.47 390.89h36.83v.25h-36.83z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "292.77px 395.235px",
          }}
          className="animable"
          d="M277.21 395.11h31.12v.25h-31.12z"
        />
        <path
          d="M237 337.8H43.91a5.71 5.71 0 0 1-5.7-5.71V60.66a5.71 5.71 0 0 1 5.7-5.66H237a5.71 5.71 0 0 1 5.71 5.71v271.38a5.71 5.71 0 0 1-5.71 5.71ZM43.91 55.2a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V60.66A5.47 5.47 0 0 0 237 55.2Z"
          style={{
            fill: "#ebebeb",
            transformOrigin: "140.46px 196.4px",
          }}
          className="animable"
        />
        <path
          d="M453.31 337.8h-193.1a5.72 5.72 0 0 1-5.71-5.71V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71ZM260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V60.66a5.47 5.47 0 0 0-5.46-5.46Z"
          style={{
            fill: "#ebebeb",
            transformOrigin: "356.75px 196.4px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "251.715px 147.5px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M105.77 89.2h291.89v116.6H105.77z"
        />
        <path
          style={{
            fill: "#e0e0e0",
            transformOrigin: "104.05px 147.5px",
          }}
          className="animable"
          d="M102.33 89.2h3.44v116.6h-3.44z"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "251.72px 147.505px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M116.28 99.71h270.88v95.59H116.28z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "327.31px 147.5px",
          }}
          className="animable"
          d="M297.79 195.29h15.23l43.81-95.58h-15.22l-43.82 95.58z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "305.76px 147.5px",
          }}
          className="animable"
          d="M276.24 195.29h15.22l43.82-95.58h-15.23l-43.81 95.58z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "164.635px 147.5px",
          }}
          className="animable"
          d="M135.11 195.29h15.23l43.82-95.58h-15.23l-43.82 95.58z"
        />
        <path
          style={{
            fill: "#e0e0e0",
            transformOrigin: "381.68px 314.53px",
          }}
          className="animable"
          d="M426.37 382.4h-82.1l-7.28-135.74h82.09l7.29 135.74z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "384.19px 314.53px",
          }}
          className="animable"
          d="M428.88 382.4h-82.1l-7.28-135.74h82.09l7.29 135.74z"
        />
        <path
          d="M383.88 368.4h-3a2.15 2.15 0 0 1-2.15-2.23l3.63-103.42a2.16 2.16 0 0 1 2.16-2.08h3a2.16 2.16 0 0 1 2.16 2.23L386 366.32a2.15 2.15 0 0 1-2.12 2.08Z"
          style={{
            fill: "#fafafa",
            transformOrigin: "384.205px 314.535px",
          }}
          className="animable"
        />
        <path
          d="M403.27 368.4h-3a2.16 2.16 0 0 1-2.15-2.23l3.63-103.42a2.17 2.17 0 0 1 2.16-2.08h3a2.16 2.16 0 0 1 2.16 2.23l-3.64 103.42a2.15 2.15 0 0 1-2.16 2.08Z"
          style={{
            fill: "#fafafa",
            transformOrigin: "403.595px 314.535px",
          }}
          className="animable"
        />
        <path
          d="M364.48 368.4h-3a2.17 2.17 0 0 1-2.16-2.23L363 262.75a2.15 2.15 0 0 1 2.15-2.08h3a2.15 2.15 0 0 1 2.15 2.23l-3.63 103.42a2.16 2.16 0 0 1-2.19 2.08Z"
          style={{
            fill: "#fafafa",
            transformOrigin: "364.81px 314.535px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "80.305px 323.67px",
          }}
          className="animable"
          d="M71.05 270.56h18.51v106.22H71.05z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "176.555px 379.595px",
          }}
          className="animable"
          d="M74.6 376.79h203.91v5.61H74.6z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "185.81px 323.67px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M89.56 270.56h192.5v106.22H89.56z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "78.18px 268.12px",
          }}
          className="animable"
          d="M68.72 265.67h18.92v4.9H68.72z"
        />
        <path
          style={{
            fill: "#fafafa",
            transformOrigin: "186.015px 268.12px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M87.64 265.67h196.75v4.9H87.64z"
        />
        <path
          d="M275.41 311.15H96.21v-30.3h179.2Zm-178-1.25h176.7v-27.81H97.46Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "185.81px 296px",
          }}
          className="animable"
        />
        <path
          d="M275.41 366.5H96.21v-47.93h179.2Zm-178-1.24h176.7v-45.44H97.46Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "185.81px 342.535px",
          }}
          className="animable"
        />
        <rect
          x={120.35}
          y={294}
          width={130.91}
          height={3.98}
          rx={1.64}
          style={{
            fill: "#e0e0e0",
            transformOrigin: "185.805px 295.99px",
          }}
          className="animable"
        />
        <rect
          x={120.35}
          y={331.73}
          width={130.91}
          height={3.98}
          rx={1.64}
          style={{
            fill: "#e0e0e0",
            transformOrigin: "185.805px 333.72px",
          }}
          className="animable"
        />
        <path
          d="M96.83 250.92c0 8.14 9.33 14.75 20.83 14.75s20.84-6.61 20.84-14.75Z"
          style={{
            fill: "#ebebeb",
            transformOrigin: "117.665px 258.295px",
          }}
          className="animable"
        />
        <path
          d="M175.85 260.67c0 2.76 9.32 5 20.83 5s20.83-2.24 20.83-5Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "196.68px 263.17px",
          }}
          className="animable"
        />
        <path
          d="M175.85 257c0 2.76 9.32 5 20.83 5s20.83-2.24 20.83-5Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "196.68px 259.5px",
          }}
          className="animable"
        />
        <path
          d="M223.74 260.67c0 2.76 9.32 5 20.83 5s20.83-2.24 20.83-5Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "244.57px 263.17px",
          }}
          className="animable"
        />
        <path
          d="M223.74 257c0 2.76 9.32 5 20.83 5s20.83-2.24 20.83-5Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "244.57px 259.5px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "250px 416.24px",
        }}
      >
        <ellipse
          cx={250}
          cy={416.24}
          rx={193.89}
          ry={11.32}
          style={{
            fill: "#f5f5f5",
            transformOrigin: "250px 416.24px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "186.4px 259.495px",
        }}
      >
        <path
          style={{
            fill: "#f6a293",
            transformOrigin: "194.16px 398.725px",
          }}
          className="animable"
          d="M189.45 407.78h7.82l1.6-18.11h-7.82l-1.6 18.11z"
        />
        <path
          d="M198.54 406.87H189a.73.73 0 0 0-.69.54l-1.79 6.95a1.1 1.1 0 0 0 1.09 1.39c3.07-.05 5.32-.23 9.18-.23 2.38 0 9.53.24 12.82.24s3.82-3.24 2.49-3.54c-6-1.31-10.45-3.13-12.32-4.87a1.82 1.82 0 0 0-1.24-.48Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "199.629px 411.315px",
          }}
          className="animable"
        />
        <path
          style={{
            opacity: 0.2,
            transformOrigin: "194.545px 394.345px",
          }}
          className="animable"
          d="M191.05 389.68h7.82l-.83 9.33h-7.82l.83-9.33z"
        />
        <path
          d="M205.68 227.71s5 60.69 3.6 83.6c-1.58 25.08-7.58 85.89-7.58 85.89h-14.32s1.25-56.63.52-81c-.82-27.81-9.21-88.11-9.21-88.11Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "194.109px 312.455px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#344f79",
            transformOrigin: "195.105px 394.825px",
          }}
          className="animable"
          d="M202.94 397.51h-16.87l.18-5.04 17.89-.33-1.2 5.37z"
        />
        <path
          d="M201.08 408.24a2.43 2.43 0 0 0 1.52-.4 1.11 1.11 0 0 0 .41-1 .54.54 0 0 0-.29-.52c-.86-.45-3.43 1.1-3.72 1.28a.19.19 0 0 0-.09.19.18.18 0 0 0 .13.15 9.13 9.13 0 0 0 2.04.3Zm1.22-1.62a.6.6 0 0 1 .24.05s.1.07.1.22a.79.79 0 0 1-.27.67 3.77 3.77 0 0 1-2.78.14 7.78 7.78 0 0 1 2.71-1.08Z"
          style={{
            fill: "#344f79",
            transformOrigin: "200.963px 407.242px",
          }}
          className="animable"
        />
        <path
          d="M199.08 408a.15.15 0 0 0 .09 0c.83-.44 2.45-2.15 2.32-3a.58.58 0 0 0-.57-.49 1.08 1.08 0 0 0-.8.24c-.93.74-1.2 3-1.21 3.09a.17.17 0 0 0 .07.17.19.19 0 0 0 .1-.01Zm1.7-3.17h.08c.24 0 .26.14.26.19.08.51-1 1.81-1.79 2.42a4.63 4.63 0 0 1 1-2.45.7.7 0 0 1 .45-.2Z"
          style={{
            fill: "#344f79",
            transformOrigin: "200.202px 406.258px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f6a293",
            transformOrigin: "138.495px 387.045px",
          }}
          className="animable"
          d="m130.71 394.05 7.31 2.51 8.26-16.52-7.31-2.51-8.26 16.52z"
        />
        <path
          d="m139.25 396.87-7.61-5.47a.68.68 0 0 0-.85.06l-5.43 4.8a1.15 1.15 0 0 0 .07 1.8c2.48 1.71 4.38 2.85 7.46 5.07 1.9 1.36 7.47 5.68 10.09 7.56s4.93-.52 4-1.54c-4-4.53-6.54-8.63-7-11.15a1.79 1.79 0 0 0-.73-1.13Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "136.075px 401.333px",
          }}
          className="animable"
        />
        <path
          d="m194.92 161.89 1.9-.42 2-.47c1.33-.33 2.66-.69 4-1.07 2.64-.77 5.24-1.62 7.75-2.59a58.83 58.83 0 0 0 7.18-3.29 29.68 29.68 0 0 0 5.94-4.2l.6-.58c.16-.19.32-.35.49-.55.34-.42.7-.88 1.05-1.4.72-1 1.44-2.14 2.12-3.32 1.35-2.37 2.69-4.87 4-7.43 2.54-5.1 5-10.4 7.44-15.63l5.59 1.8a145 145 0 0 1-4.81 17.26c-1 2.84-2 5.69-3.34 8.54a53.25 53.25 0 0 1-2.19 4.32c-.42.73-.89 1.47-1.42 2.23-.26.38-.59.78-.88 1.16l-.89 1a35.7 35.7 0 0 1-3.81 3.6 47.84 47.84 0 0 1-4.1 2.9 59.57 59.57 0 0 1-8.57 4.43 78.12 78.12 0 0 1-8.83 3.15q-2.23.66-4.5 1.2c-.75.19-1.51.37-2.28.53s-1.49.29-2.4.45Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "219.95px 147.225px",
          }}
          className="animable"
        />
        <path
          d="M191 175.38c6 4.23 27.83-2.7 27.83-2.7l-3-19.29s-8.93 2.11-18.3 4.86c-6.37 1.84-13.12 12.53-6.53 17.13Z"
          style={{
            fill: "#344f79",
            transformOrigin: "203.564px 165.069px",
          }}
          className="animable"
        />
        <path
          d="m238.42 124.07 1.48-8.25 7.52 4.81a8.8 8.8 0 0 1-4.25 5.52Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "242.92px 120.985px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f6a293",
            transformOrigin: "243.87px 114.84px",
          }}
          className="animable"
          d="m242.02 111.13 5.82-2.08-.41 11.58-7.53-4.81 2.12-4.69z"
        />
        <path
          style={{
            opacity: 0.2,
            transformOrigin: "140.49px 383.045px",
          }}
          className="animable"
          d="m138.97 377.53 7.31 2.52-4.26 8.51-7.32-2.51 4.27-8.52z"
        />
        <path
          d="M163 160.28a173.31 173.31 0 0 1 2.56 26c.17 6.1.08 11.89-.14 17.15-.49 12.3-1.63 21.64-1.56 24.84l41.83-.52c9.8-44.08 1.13-67.58 1.13-67.58a79.52 79.52 0 0 0-9.84-1.81c-.7-.08-1.41-.15-2.14-.21a154.74 154.74 0 0 0-17.79.22c-1.12.07-2.26.17-3.37.28-5.68.55-10.68 1.63-10.68 1.63Z"
          style={{
            fill: "#344f79",
            transformOrigin: "186.68px 193.131px",
          }}
          className="animable"
        />
        <path
          d="M177 158.33a154.74 154.74 0 0 1 17.79-.22c.72.06 1.44.13 2.14.21h.25c1 2.68 1.13 8.46-4.74 8.93-8 .64-15.44-4.59-18.81-8.66 1.14-.09 2.29-.19 3.37-.26Z"
          style={{
            fill: "#fff",
            transformOrigin: "185.668px 162.628px",
          }}
          className="animable"
        />
        <path
          d="M172.44 172.12a34 34 0 0 1-6.83 17.75c0-1.19 0-2.4-.06-3.62-.13-4.58-.41-9.33-.91-14.14Z"
          style={{
            opacity: 0.2,
            transformOrigin: "168.54px 180.99px",
          }}
          className="animable"
        />
        <path
          d="M179.28 138.29c1 5.71 1.86 16.18-2.24 20a17.17 17.17 0 0 0 13.59 5.28c4.93-.16 5.25-3.61 4.2-5.5-6.35-1.44-6.07-6.18-4.85-10.64Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "186.179px 150.95px",
          }}
          className="animable"
        />
        <path
          d="m183.64 142 6.33 5.43a18.77 18.77 0 0 0-.62 3.16c-2.43-.32-5.72-2.95-5.92-5.5a8.6 8.6 0 0 1 .21-3.09Z"
          style={{
            opacity: 0.2,
            transformOrigin: "186.672px 146.295px",
          }}
          className="animable"
        />
        <path
          d="M200.94 122.28c4.78-2.39 2.59-9.72 2.59-9.72s-2.53-.06-5.29 3c1.25-3.78-.85-9.94-1.55-12.33-9.59 4.16-10.23 8.18-10.23 8.18s-2-3-3.88-3.17a8.1 8.1 0 0 0-3.58 9 12.27 12.27 0 0 0-5.17-1.62 9.94 9.94 0 0 0 .33 6.93 5.86 5.86 0 0 0-2.55 2.59 14.38 14.38 0 0 0 2.78 1.37c-.15 3 .49 7.14 2.65 9.48l22-10.28c3.72 1.61 5.38.45 5.38.45s-.86-3.16-3.48-3.88Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "188.015px 119.61px",
          }}
          className="animable"
        />
        <path
          d="M178.8 129.69c.29 7.74.07 12.3 3.89 16.23 5.75 5.9 15.39 2.24 17.42-5.52 1.83-7 1-18.46-6.47-21.45S178.5 122 178.8 129.69Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "189.863px 133.504px",
          }}
          className="animable"
        />
        <path
          d="M185.94 121c.5 4.06-5 7.06-3.72 13.06a17.3 17.3 0 0 1-3.43 3.75l-2.23-6.11 1.11-11.2 7.44-.63Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "181.266px 128.84px",
          }}
          className="animable"
        />
        <path
          d="M180.78 120.5c5.83 3.78 15.61 3.11 18.33 2.17-1.36-4.89-6.83-6.28-6.83-6.28s-9.17-.83-11.5 4.11Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "189.945px 119.87px",
          }}
          className="animable"
        />
        <path
          d="M192.8 140.37a5.48 5.48 0 0 1-4.66-2.25.22.22 0 0 1 .07-.28.19.19 0 0 1 .27.06 5.21 5.21 0 0 0 4.33 2.07.19.19 0 0 1 .19.2.2.2 0 0 1-.2.2Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "190.558px 139.091px",
          }}
          className="animable"
        />
        <path
          d="M175.1 138.27a7 7 0 0 0 4.52 3.2c2.51.53 3.69-1.78 2.92-4.08-.7-2.07-2.84-4.83-5.33-4.32a3.39 3.39 0 0 0-2.11 5.2Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "178.65px 137.277px",
          }}
          className="animable"
        />
        <path
          d="m185.42 246.66-3.42 6.73c1.57 12.72 3.37 28.32 4.57 42.11 2.73-13.87 4.5-40.5-1.15-48.84Z"
          style={{
            opacity: 0.2,
            transformOrigin: "185.571px 271.08px",
          }}
          className="animable"
        />
        <path
          d="M192.37 227.88s-9.72 55.46-14.06 78.1C173.55 330.77 146 388 146 388l-13.39-4.6s22.13-57 24.53-81.46c2.73-27.81 6.67-73.72 6.67-73.72Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "162.49px 307.94px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#344f79",
            transformOrigin: "140.635px 383.61px",
          }}
          className="animable"
          d="m147.1 388.71-15.78-5.42 1.79-4.78 16.84 5.44-2.85 4.76z"
        />
        <path
          d="M190.5 131.71c0 .63.31 1.14.72 1.13s.76-.52.77-1.15-.3-1.14-.72-1.13-.76.52-.77 1.15Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "191.245px 131.7px",
          }}
          className="animable"
        />
        <path
          d="M197.63 131.62c0 .63.31 1.14.72 1.13s.76-.52.78-1.15-.31-1.13-.73-1.13-.75.53-.77 1.15Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "198.38px 131.61px",
          }}
          className="animable"
        />
        <path
          d="M195.36 132a21.84 21.84 0 0 0 2.88 5.36c-1.14 1.06-3.1.45-3.1.45Z"
          style={{
            fill: "#ed893e",
            transformOrigin: "196.69px 134.992px",
          }}
          className="animable"
        />
        <path
          d="M188.34 129.43a.37.37 0 0 0 .36-.14 3.08 3.08 0 0 1 2.41-1.27.38.38 0 0 0 .4-.35.35.35 0 0 0-.33-.39 3.84 3.84 0 0 0-3.06 1.57.38.38 0 0 0 .06.52.44.44 0 0 0 .16.06Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "189.778px 128.358px",
          }}
          className="animable"
        />
        <path
          d="M200.75 129.13a.35.35 0 0 0 .22 0 .38.38 0 0 0 .19-.49 3.49 3.49 0 0 0-2.62-2 .38.38 0 0 0-.42.32.36.36 0 0 0 .31.41 2.81 2.81 0 0 1 2 1.65.35.35 0 0 0 .32.11Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "199.653px 127.893px",
          }}
          className="animable"
        />
        <path
          d="M140.49 399.48a2.3 2.3 0 0 0 1.44.53 1.15 1.15 0 0 0 .9-.58.58.58 0 0 0 .06-.61c-.42-.86-3.37-1-3.7-1.06a.19.19 0 0 0-.18.11.16.16 0 0 0 0 .2 8.59 8.59 0 0 0 1.48 1.41Zm1.9-.66a.46.46 0 0 1 .17.17.25.25 0 0 1 0 .25.78.78 0 0 1-.61.4c-.55.05-1.4-.49-2.3-1.47a7.14 7.14 0 0 1 2.74.65Z"
          style={{
            fill: "#344f79",
            transformOrigin: "140.962px 398.885px",
          }}
          className="animable"
        />
        <path
          d="M139.06 398.1a.11.11 0 0 0 .08 0c.91.11 3.2-.4 3.59-1.21a.59.59 0 0 0-.18-.73 1 1 0 0 0-.77-.26c-1.17.09-2.68 1.83-2.75 1.9a.19.19 0 0 0 0 .19.16.16 0 0 0 .03.11Zm3.17-1.69h.06c.18.17.13.27.11.31-.23.48-1.81 1-2.82 1a4.69 4.69 0 0 1 2.21-1.48.63.63 0 0 1 .44.17Z"
          style={{
            fill: "#344f79",
            transformOrigin: "140.897px 397.005px",
          }}
          className="animable"
        />
        <path
          d="m170.38 172.29-2.46 3c-.83 1-1.65 2.05-2.46 3.1q-2.43 3.12-4.74 6.32c-1.51 2.14-3 4.3-4.34 6.48s-2.63 4.4-3.68 6.62l-.21.42-.08.19a2.59 2.59 0 0 0-.18.47 11 11 0 0 0-.32 1.38 27.43 27.43 0 0 0-.36 3.47c-.1 2.47-.07 5.1.07 7.74.26 5.28.74 10.74 1.27 16.1l-5.72 1.33a113.84 113.84 0 0 1-4.45-16.36 72.55 72.55 0 0 1-1.14-8.69 39.68 39.68 0 0 1 0-4.76 23.49 23.49 0 0 1 .37-2.68c.12-.49.21-.95.4-1.51l.26-.78.21-.52a83.21 83.21 0 0 1 8.18-15.55c1.58-2.4 3.24-4.72 5-7 .87-1.13 1.76-2.24 2.67-3.35s1.81-2.16 2.85-3.32Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "155.944px 196.65px",
          }}
          className="animable"
        />
        <path
          d="M163 160.28c-7.44 1.06-15.51 18.58-15.51 18.58l14.08 13.32s5.84-8.81 10.65-17.36c5.23-9.31-.22-15.82-9.22-14.54Z"
          style={{
            fill: "#344f79",
            transformOrigin: "160.875px 176.15px",
          }}
          className="animable"
        />
        <path
          d="m152.21 225.89 4.71 6.23-9.79 2.37s-2.8-6.23.4-8.2Z"
          style={{
            fill: "#f6a293",
            transformOrigin: "151.458px 230.19px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f6a293",
            transformOrigin: "152.025px 236.175px",
          }}
          className="animable"
          d="m156.76 238.65-8.17 1.58-1.46-5.74 9.79-2.37-.16 6.53z"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "314.822px 261.795px",
        }}
      >
        <path
          style={{
            fill: "#ffc3bd",
            transformOrigin: "370.685px 383.32px",
          }}
          className="animable"
          d="m379.49 389.66-7.38 3.16-10.23-15.83 7.37-3.17 10.24 15.84z"
        />
        <path
          style={{
            opacity: 0.2,
            transformOrigin: "368.21px 379.485px",
          }}
          className="animable"
          d="m369.26 373.82-7.38 3.17 5.28 8.16 7.38-3.16-5.28-8.17z"
        />
        <path
          d="M311.75 230.21s13 65.44 19.51 88C338.39 343 363 384.92 363 384.92l13.51-5.8s-15-33.8-21-58.2c-6.79-27.78-16.18-93-16.18-93Z"
          style={{
            fill: "#344f79",
            transformOrigin: "344.13px 306.42px",
          }}
          className="animable"
        />
        <path
          d="M322.51 249c1.67 18.19 2.07 31 2.76 45.08-3.42-14.94-7.07-32.26-9.72-45.08Z"
          style={{
            opacity: 0.2,
            transformOrigin: "320.41px 271.54px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#ffc3bd",
            transformOrigin: "320.685px 398.64px",
          }}
          className="animable"
          d="m325.62 408.01-8.03-.12-1.84-18.62 8.02.12 1.85 18.62z"
        />
        <path
          style={{
            opacity: 0.2,
            transformOrigin: "320.24px 394.135px",
          }}
          className="animable"
          d="m315.75 389.27.95 9.6 8.03.13-.95-9.6-8.03-.13z"
        />
        <path
          d="m313.72 397 13.59.21s-5.36-52.81-7.12-77.76c-.54-7.59-.29-18.32.35-29.87.8-14.56 1.33-20.39 2.43-38.79.78-13.12 1.73-21.62 1.73-21.62l-28.13 2.31s-1.1 63.71 2.09 88C302 344.7 313.72 397 313.72 397Z"
          style={{
            fill: "#344f79",
            transformOrigin: "311.848px 313.19px",
          }}
          className="animable"
        />
        <path
          d="m317.66 407 8.77.14a.68.68 0 0 1 .67.55l1.48 7.16a1.16 1.16 0 0 1-1.18 1.41c-3.16-.1-7.73-.36-11.7-.42-4.65-.07-5.18.12-10.63 0-3.29-.05-4.15-3.39-2.77-3.67 6.3-1.28 7.94-1.35 13.42-4.61a3.77 3.77 0 0 1 1.94-.56Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "315.138px 411.63px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#344f79",
            transformOrigin: "319.625px 394.615px",
          }}
          className="animable"
          d="m312.01 397.26 16.19.25.09-5.23-17.33-.56 1.05 5.54z"
        />
        <path
          style={{
            opacity: 0.3,
            transformOrigin: "319.625px 394.615px",
          }}
          className="animable"
          d="m312.01 397.26 16.19.25.09-5.23-17.33-.56 1.05 5.54z"
        />
        <path
          d="M316.86 408.06a.24.24 0 0 0 .13-.16.19.19 0 0 0-.1-.19c-.36-.2-3.56-1.88-4.55-1.36a.62.62 0 0 0-.32.51 1.09 1.09 0 0 0 .34.93c.87.79 3.18.51 4.47.27Zm-4.27-1.4c.61-.2 2.35.49 3.61 1.12-1.77.27-3.09.17-3.58-.27a.72.72 0 0 1-.22-.62.22.22 0 0 1 .12-.2Z"
          style={{
            fill: "#344f79",
            transformOrigin: "314.502px 407.281px",
          }}
          className="animable"
        />
        <path
          d="M316.86 408.06h.05a.21.21 0 0 0 .08-.17c0-.09-.19-2.26-1.2-3.11a1.37 1.37 0 0 0-1.05-.34c-.52 0-.68.3-.72.52-.16.9 1.74 2.67 2.7 3.12a.22.22 0 0 0 .14-.02Zm-2.28-3.24h.19a1 1 0 0 1 .77.26 4.38 4.38 0 0 1 1 2.49c-1-.61-2.26-2-2.16-2.54.02-.03.04-.16.2-.21Zm.18-.22Z"
          style={{
            fill: "#344f79",
            transformOrigin: "315.5px 406.258px",
          }}
          className="animable"
        />
        <path
          d="m370.43 392.45 8.41-5a.7.7 0 0 1 .87.12l5 5.32a1.18 1.18 0 0 1-.28 1.83c-2.73 1.56-4.8 2.58-8.2 4.61-2.1 1.25-6.94 4.37-9.83 6.09s-4.92-.85-4-1.87c4.36-4.6 6.32-7.46 7.11-10a1.94 1.94 0 0 1 .92-1.1Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "373.601px 396.674px",
          }}
          className="animable"
        />
        <path
          d="m252 124.57 1.56-7-8.29-2.41s-2.52 6.77 2.35 10Z"
          style={{
            fill: "#ffc3bd",
            transformOrigin: "249.089px 120.16px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#ffc3bd",
            transformOrigin: "249.395px 112.47px",
          }}
          className="animable"
          d="m252.48 110.79-6.44-3.46-.79 7.87 8.29 2.41-1.06-6.82z"
        />
        <path
          d="M292.32 175.67c-3.08-.86-5.87-1.81-8.76-2.85s-5.69-2.17-8.5-3.41-5.59-2.54-8.35-4c-1.38-.7-2.75-1.5-4.12-2.28l-2-1.25-.51-.31-.76-.5q-.75-.53-1.41-1.08a21.49 21.49 0 0 1-4.05-4.68 34.29 34.29 0 0 1-2.56-4.72 54.43 54.43 0 0 1-3.08-9.3 84.07 84.07 0 0 1-2.27-18.44l7.37-1a158.6 158.6 0 0 0 5.51 16 52.2 52.2 0 0 0 3.52 7.06 22.3 22.3 0 0 0 2 2.83 9.87 9.87 0 0 0 1.93 1.77 4 4 0 0 0 .37.22.55.55 0 0 1 .18.08l.46.21 1.82.88c1.26.56 2.5 1.13 3.78 1.67 2.55 1.09 5.17 2.1 7.81 3.1s5.31 2 8 2.88l8 2.73Z"
          style={{
            fill: "#344f79",
            transformOrigin: "271.325px 148.76px",
          }}
          className="animable"
        />
        <path
          d="M318.84 137c-.58 5.95-.68 16.77 3.79 20.27-2.87 3.47-6.66 7.52-13.58 8.44s-6.17-4-4.58-6.67c6.37-2.19 5.73-7 4.15-11.44Z"
          style={{
            fill: "#ffc3bd",
            transformOrigin: "313.013px 151.412px",
          }}
          className="animable"
        />
        <path
          d="M300.7 131.22c-.07.65-.46 1.14-.88 1.1s-.71-.6-.65-1.25.46-1.13.88-1.09.71.6.65 1.24Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "299.935px 131.15px",
          }}
          className="animable"
        />
        <path
          d="M300.47 131.85a23 23 0 0 1-3.62 5.21 3.71 3.71 0 0 0 3 .88Z"
          style={{
            fill: "#ed847e",
            transformOrigin: "298.66px 134.916px",
          }}
          className="animable"
        />
        <path
          d="M302.42 128.81a.37.37 0 0 1-.23-.27 3 3 0 0 0-1.71-2.15.38.38 0 1 1 .26-.72 3.81 3.81 0 0 1 2.19 2.7.38.38 0 0 1-.29.45.33.33 0 0 1-.22-.01Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "301.583px 127.241px",
          }}
          className="animable"
        />
        <path
          d="M322.7 131.74c-1.55 7.82-2.06 12.47-6.58 16-6.81 5.28-16.05.36-16.87-7.76-.74-7.31 1.91-18.86 10.05-21a10.87 10.87 0 0 1 13.4 12.76Z"
          style={{
            fill: "#ffc3bd",
            transformOrigin: "311.033px 134.277px",
          }}
          className="animable"
        />
        <path
          d="M306.83 133.92c-2.25-2.59-1.41-8.17 0-10.84-1.66 1.06-7.31.68-7.34-3.75-.05-6.49 10.86-8 16.84-6.86 6.89 1.36 13.07 7.82 15.45 5.59 2.45 4.32-1.84 5.83-1.84 5.83s4.26 10.75-11.33 21.28a17.77 17.77 0 0 0-6.42.27 1.85 1.85 0 0 1-1.29-.53c-1.58-1.58-5.9-6.46-4.07-10.99Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "316.013px 128.781px",
          }}
          className="animable"
        />
        <path
          d="M329.35 123.65s2.94.62 3.94-1.27c-.29 2.7-1.94 2.72-3.94 1.27Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "331.32px 123.495px",
          }}
          className="animable"
        />
        <path
          d="M312 136.4a7.56 7.56 0 0 1-4.56 3.56c-2.56.68-3.82-1.62-3.08-4 .66-2.17 2.8-5.13 5.36-4.76s3.45 3.06 2.28 5.2Z"
          style={{
            fill: "#ffc3bd",
            transformOrigin: "308.329px 135.625px",
          }}
          className="animable"
        />
        <path
          d="M342.53 164.1c1.15 1.1 2.09 2.09 3.08 3.15s1.93 2.11 2.84 3.2c1.85 2.15 3.61 4.38 5.33 6.64s3.36 4.58 4.91 7L360 186c.49.72.89 1.46 1.31 2.19a35.35 35.35 0 0 1 2.05 4.5 46.4 46.4 0 0 1 2.43 9 60.46 60.46 0 0 1 .85 8.92 72.54 72.54 0 0 1-.26 8.74 68.08 68.08 0 0 1-1.28 8.66l-7.39-.81c-.13-2.49-.32-5.21-.61-7.79s-.67-5.18-1.14-7.7a52.84 52.84 0 0 0-4.41-13.94 28.68 28.68 0 0 0-1.67-2.84c-.31-.43-.6-.88-.92-1.27-.18-.21-.29-.37-.51-.62l-.65-.76c-1.76-2-3.5-4-5.29-6s-3.56-4-5.34-5.91l-5.25-5.75Z"
          style={{
            fill: "#344f79",
            transformOrigin: "349.297px 196.055px",
          }}
          className="animable"
        />
        <path
          d="M322.74 170.45c-1.28 5.79 16.49 16.33 16.49 16.33l14.06-12a104.89 104.89 0 0 0-12-14.29c-7.29-7.26-16.47.58-18.55 9.96Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "337.982px 172.212px",
          }}
          className="animable"
        />
        <path
          d="M335.09 176.52c-2.54-1.39-2.93 1.78-2.54 5.81 3.54 2.59 6.67 4.45 6.67 4.45l1.79-1.53c-1.41-3.69-3.37-7.34-5.92-8.73Z"
          style={{
            opacity: 0.2,
            transformOrigin: "336.715px 181.484px",
          }}
          className="animable"
        />
        <path
          d="m357.55 225.94-3.7 4.94 8.89 3.67s2.32-4 1.83-7a3 3 0 0 0-2.29-2.35l-1.62-.38a3 3 0 0 0-3.11 1.12Z"
          style={{
            fill: "#ffc3bd",
            transformOrigin: "359.244px 229.643px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#ffc3bd",
            transformOrigin: "357.4px 235.775px",
          }}
          className="animable"
          d="m352.06 238.81 8.38 1.86 2.3-6.12-8.89-3.67-1.79 7.93z"
        />
        <path
          d="M338.3 161.76c-3.64 30.74 6.16 68.68 6.4 75-6.28.52-37.32 3.38-50.21 4.43-7.48-54.73-.59-80.69-.59-80.69s2.67-.86 6.34-1.69c1.15-.26 2.4-.51 3.7-.74.71-.13 1.45-.24 2.19-.35a160.91 160.91 0 0 1 18.23-.82c1.15 0 2.33 0 3.47.09s2.09.12 3.07.19c1.51.12 2.91.26 4.1.39a3.75 3.75 0 0 1 3.3 4.19Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "317.853px 199.039px",
          }}
          className="animable"
        />
        <path
          d="M291.76 175.27c-.15 1.57-.27 3.28-.37 5.12 2.84-.28 6.29-1 7.75-2.64 1.78-2.08-3.66-2.45-7.38-2.48Z"
          style={{
            opacity: 0.2,
            transformOrigin: "295.439px 177.83px",
          }}
          className="animable"
        />
        <path
          d="M302.47 178.07c-6.87 3.4-19.88-2.4-19.88-2.4l.21-20.17s14.05 2.26 24 2.16c10.2-.1 3.2 16.67-4.33 20.41Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "297.248px 167.319px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#344f79",
            transformOrigin: "367.375px 380.11px",
          }}
          className="animable"
          d="m361.51 385.9 15.91-6.82-2.04-4.76-18.05 5.94 4.18 5.64z"
        />
        <path
          style={{
            opacity: 0.3,
            transformOrigin: "367.375px 380.11px",
          }}
          className="animable"
          d="m361.51 385.9 15.91-6.82-2.04-4.76-18.05 5.94 4.18 5.64z"
        />
        <path
          d="M368.87 395a9.44 9.44 0 0 0 1.66-1.32.18.18 0 0 0 0-.2.17.17 0 0 0-.17-.12c-.35 0-3.38-.05-3.91.79a.6.6 0 0 0 0 .63 1.15 1.15 0 0 0 .85.66 2.36 2.36 0 0 0 1.57-.44Zm1.05-1.27c-1 .94-2 1.43-2.52 1.34a.78.78 0 0 1-.58-.46.22.22 0 0 1 0-.25c.26-.43 1.88-.6 3.1-.62Z"
          style={{
            fill: "#344f79",
            transformOrigin: "368.46px 394.403px",
          }}
          className="animable"
        />
        <path
          d="M370.49 393.72a.3.3 0 0 0 .08-.08.19.19 0 0 0 0-.19c-.06-.08-1.41-2-2.6-2.15a1 1 0 0 0-.82.2.62.62 0 0 0-.26.74c.31.86 2.59 1.54 3.53 1.51Zm-3.06-2a.74.74 0 0 1 .47-.08c.76.12 1.67 1.14 2.1 1.68-1-.12-2.59-.74-2.78-1.24 0-.05-.05-.16.14-.31Z"
          style={{
            fill: "#344f79",
            transformOrigin: "368.724px 392.516px",
          }}
          className="animable"
        />
      </g>
      <AnimateHit
        className="animable"
        style={{
          transformOrigin: "249.165px 95.155px",
        }}
      >
        <path
          style={{
            fill: "#344f79",
            opacity: 0.9,
            transformOrigin: "246.665px 79.725px",
          }}
          className="animable"
          d="M246.08 76.89h1.17v5.67h-1.17z"
        />
        <path
          style={{
            fill: "#344f79",
            opacity: 0.9,
            transformOrigin: "246.665px 92.495px",
          }}
          className="animable"
          d="M246.08 85.33h1.17v14.33h-1.17z"
        />
        <path
          style={{
            fill: "#344f79",
            opacity: 0.9,
            transformOrigin: "256.815px 102.685px",
            transform: "rotate(-44.97deg)",
          }}
          className="animable"
          d="M252.48 102.1h8.67v1.17h-8.67z"
        />
        <path
          style={{
            fill: "#344f79",
            opacity: 0.9,
            transformOrigin: "265.365px 112.835px",
          }}
          className="animable"
          d="M260.84 112.25h9.05v1.17h-9.05z"
        />
        <path
          style={{
            fill: "#344f79",
            opacity: 0.9,
            transformOrigin: "235.235px 101.415px",
            transform: "rotate(-45deg)",
          }}
          className="animable"
          d="M234.65 95.28h1.17v12.27h-1.17z"
        />
        <path
          style={{
            fill: "#344f79",
            opacity: 0.9,
            transformOrigin: "230.465px 112.835px",
          }}
          className="animable"
          d="M228.44 112.25h4.05v1.17h-4.05z"
        />
      </AnimateHit>
    </svg>
  )
}